export default {
  directives: {
    // 自定义options导致select绑定item时无法删除，通过拿到点击的tag找出index进行删除
    deselect: {
      bind (el, binding, vNode) {
        const vm = vNode.context // 绑定this
        // 查找类名包含的dom
        function findNodeClassName (target, name, tag = 'LI') {
          if (target) {
            const className = typeof target.className === 'string' ? target.className : ''
            if (className.indexOf(name) >= 0 && target.tagName === tag) {
              return target
            }
            return findNodeClassName(target.parentElement, name, tag)
          }
          return null
        }
        // 获取下标
        function getIndex (current, obj) {
          for (let i = 0, { length } = obj.children; i < length; i++) {
            if (obj.children[i] === current) {
              return i
            }
          }
          return -1
        }
        // 事件委托
        const func = (e) => {
          console.log(23323323)
          // clear all
          if (e.target && findNodeClassName(e.target, 'home-ant-select-selection__clear', 'SPAN')) {
            if (vm.mode === 'default') {
              vm.$emit('input', undefined)
            } else if (vm.mode === 'multiple') {
              const dataValue = vm.value.map(item => item.value)
              dataValue.forEach(item => {
                const tempObj = vm.hookOptions.find(e => e.value === item)
                if (tempObj) {
                  tempObj.flag = false
                }
              })
              vm.$emit('input', [])
              vm.$emit('clear', e)
              if (vm.type !== 'all') {
                vm.filterOption('')
              }
            }
          }
          // remove item 204016837
          if (e.target && findNodeClassName(e.target, 'select-selection__choice__remove', 'SPAN')) {
            const find = findNodeClassName(e.target, 'select-selection__choice')
            if (find) {
              const index = getIndex(find, find.parentElement)
              const del = vm.value.splice(index, 1)
              for (const i of vm.hookOptions) {
                if (del[0][vm.optionsFields.value] === i[vm.optionsFields.value]) {
                  i.flag = false
                  break
                }
              }
              vm.$forceUpdate()
            }
          }
        }
        // 关闭委托
        const closeFunc = (e) => {
          if (!vm.selectOpen) return
          const node = findNodeClassName(e.target, 'v-select-main', 'DIV')
          const vselect = vm.$refs?.['vSelect']?.$el || vm.$refs?.['vSelect']
          const dropdownRenderNode = findNodeClassName(e.target, 'home-ant-select-dropdown-content', 'DIV')
          const dropdownRender = vm.$refs?.['vSelect']?.$slots.dropdownRender[0].elm
          if (node !== vselect && dropdownRenderNode !== dropdownRender) {
            vm.search = ''
            if (vm.type !== 'all' && vm.refresh) {
              vm.filterOption(vm.search)
              vm.refresh = false
            }
            vm.selectOpen = false
          }
        }
        window.addEventListener('click', closeFunc, true)
        el.addEventListener('click', func, true)
        vm.$once('hook:beforeDestroy', () => {
          el.removeEventListener('click', func, true)
        })
      }
    }
  }
}
